import GUID from 'common/helpers/GUID'
import isNil from 'lodash/isNil'
import get from 'lodash/get'

export const ATTEND_ACTIVITY_TYPES = {
  live: 0,
  richClientZoom: 1,
  onDemand: 2
}

export const ATTEND_ACTIVITY_TYPES_MAP = {
  [ATTEND_ACTIVITY_TYPES.live]: "Attended",
  [ATTEND_ACTIVITY_TYPES.richClientZoom]: "Opened in Zoom",
  [ATTEND_ACTIVITY_TYPES.onDemand]: "Viewed Recording"
}

export const EVENT_TYPES = {
  zoom: "zoom",
  stream: "stream",
  simulive: "simulive"
}

export const DEFAULT_SCHEDULE_CONFIG = {
  is_enabled: false,
  times: {
    start_time: null,
    end_time: null
  }
}

const SECOND_IN_MILLISECONDS = 1000

export const DEFAULT_LABEL = "Ready to join?"
export const ATTEND_ACTIVITY_ACTION_NAME = "attend_activity"

export const createUniqueId = () => {
  return GUID.createRandomGuid()
}

export const getActivityType = (eventType, scheduleConfig, videoSourceConfig) => {
  switch (eventType) {
    case EVENT_TYPES.zoom:
      return ATTEND_ACTIVITY_TYPES.live
    case EVENT_TYPES.stream:
      return scheduleConfig.is_enabled ?
        getStreamEventActivityType(scheduleConfig) : ATTEND_ACTIVITY_TYPES.onDemand
    case EVENT_TYPES.simulive:
      return scheduleConfig.is_enabled ?
        getSimuliveEventActivityType(videoSourceConfig, scheduleConfig) : ATTEND_ACTIVITY_TYPES.onDemand
  }
}

const getScheduleTime = (scheduleConfig, timePoint) => {
  return get(scheduleConfig, `times.${timePoint}_time.scheduled_at`, null)
}

const isSimuliveEventLive = (videoSourceConfig, scheduleConfig) => {
  const now = Math.round(Date.now() / SECOND_IN_MILLISECONDS)
  const startTime = getScheduleTime(scheduleConfig, "start")
  const endTime = startTime + videoSourceConfig.duration
  return (now >= startTime) && (now <= endTime)
}

const getSimuliveEventActivityType = (videoSourceConfig, scheduleConfig) => {
  if (!videoSourceConfig.isOnDemand) {
    return ATTEND_ACTIVITY_TYPES.live
  }
  return isSimuliveEventLive(videoSourceConfig, scheduleConfig) ?
    ATTEND_ACTIVITY_TYPES.live : ATTEND_ACTIVITY_TYPES.onDemand
}

const getStreamEventActivityType = (scheduleConfig) => {
  return isNil(getScheduleTime(scheduleConfig, "end")) ?
    ATTEND_ACTIVITY_TYPES.onDemand : ATTEND_ACTIVITY_TYPES.live
}